import * as React from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import {withStyles} from "@mui/styles";
import {Styles} from "../../../../config/design/styles";
import {connect, setStore} from "trim-redux";
import {useTranslation} from "react-i18next";
import {useLocation, useNavigate} from "react-router-dom";
import Button from "@mui/material/Button";
import {HeartHandshake,Utensils, Store} from "lucide-react";
import {useMediaQuery} from "@mui/material";
import {theme} from "../../../../config/design/theme";
import {Link} from "react-router-dom";
import {defaultVariables} from "../../../../config";
import LanguageSwitcher from "./LanguageSwitcher";

function MenuTabs({style,global_menu}) {
    const location = useLocation();
    const [value, setValue] = React.useState(location.pathname);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));


    return (
        <div style={{display:"flex",alignItems:'center',justifyContent:"space-between",width:"100%"}}>
            <Box style={style} className="top-menu-items">
                <Button
                    component={"a"}
                    target="_blank"
                    href="https://kolaydoy.net"
                    color={'text'}
                >
                    {t('mainSite')}
                </Button>
                <Button
                    component={"a"}
                    target="_blank"
                    href="https://kolaydoy.org"
                    color={'text'}
                >
                    {t('contactUs')}
                </Button>
                <Button
                    component={"a"}
                    href={`${defaultVariables.website}/check`}
                    target="_blank"
                    color="primary"
                    size="small"
                    variant="outlined"
                >
                    {t('checkStock')}
                </Button>
                <LanguageSwitcher/>
            </Box>
        </div>

    );
}
const mstp = state => ({
    navCollapsed: state.navCollapsed,
    logo: state.logo,
    user: state.user,
    isAuth: state.isAuth,
    global_menu: state.global_menu,
});
export default withStyles(Styles)(connect(mstp)(MenuTabs));